import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const ChevronLeftSmall = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M9.82312 12.0101L6.25012 8.4368C6.2269 8.41361 6.20848 8.38607 6.19591 8.35576C6.18334 8.32544 6.17687 8.29295 6.17687 8.26013C6.17687 8.22732 6.18334 8.19482 6.19591 8.16451C6.20848 8.13419 6.2269 8.10665 6.25012 8.08347L9.82312 4.51013"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
